export const numberWithCommaWithoutDecimals = (
  value: any,
  withSymbol?: boolean
) => {
  const parse = new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  })?.format(value)

  const result = parse?.replace('$', '')

  return `${withSymbol ? '$ ' : ''}${result}`
}

export const stringNumberFormatToSimpleNumber = (value: string) => {
  const newValue = value?.replace(/[^0-9]|\$|,/g, '')?.trim()
  return parseInt(newValue, 10)
}

export const getFirstTwoLetters = (input: string): string => {
  const words = input?.split(' ')
  let result = ''

  for (let i = 0; i < 2 && i < words?.length; i++) {
    const firstTwoLetters = words[i]?.slice(0, 1)?.toUpperCase()
    result += firstTwoLetters
  }

  return result
}

export const formatPhoneNumberWithCountryCode = (number: string): string => {
  if (!number) {
    return ''
  }

  const numberWithoutFormat = number?.replace(/\s/g, '')?.replace(/[^0-9]/g, '')

  const countryNumber = numberWithoutFormat?.substring(0, 2)
  const numberWithoutCountryNumber = numberWithoutFormat?.substring(2)

  const lada = numberWithoutCountryNumber?.substring(0, 3)
  const prefix = numberWithoutCountryNumber?.substring(3, 6)
  const phoneNumber = numberWithoutCountryNumber?.substring(6)

  return `+${countryNumber} ${lada} ${prefix} ${phoneNumber}`
}

export function abbreviateNumber(params: { value: number }): string {
  const { value } = params

  const mil = 1000
  const million = 1000000

  const toStringDecimal = (params: { from: number; limit: number }) => {
    const { from, limit } = params
    const result = (from / limit)?.toFixed(1)
    const toNumber = parseFloat(result)
    return toNumber?.toString()
  }

  if (Math.abs(value) >= million) {
    const result = toStringDecimal({
      from: value,
      limit: million
    })
    return `${result}M`
  } else if (Math.abs(value) >= mil) {
    const result = toStringDecimal({
      from: value,
      limit: mil
    })
    return `${result}K`
  } else {
    return value?.toString()
  }
}

/**
 * @param value number parameter
 * @returns number compact notation formatter (K, M, T)
 */
export const milFormate = (params: { value: number; compact?: boolean }) => {
  const { value, compact = false } = params

  const formatter = new Intl.NumberFormat('en', {
    maximumSignificantDigits: 6,
    notation: 'compact'
  })
  const format = formatter.format(value)
  const key = format.slice(-1)

  const filter = format.substring(0, format.length - 1)
  const split = filter.split('.')

  let number = split[0]
  if (split[1]) {
    const decimal = split[1][0].toString()
    if (decimal !== '0') {
      number = `${number}.${split[1][0]}`
    }
  }

  let notation: string
  switch (key) {
    case 'K':
      notation = compact ? 'K' : 'Mil'
      break
    case 'M':
      notation = compact ? 'M' : 'Millones'
      break
    default:
      notation = ''
  }

  return {
    number,
    notation
  }
}

export const currencyString = (currency: number) => {
  return new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  })?.format(currency)
}
